export function formatYear(year: number): string {
  const roundedYear = Math.round(year);
  if (roundedYear < 0) {
    return `${Math.abs(roundedYear)} BCE`;
  }

  return `${roundedYear} CE`;
}

const KM_TO_MILES = 0.621371;

export function kmToMiles(km: number): number {
  return km * KM_TO_MILES;
}

export function formatDistance(km: number): string {
  if (!Number.isFinite(km)) {
    return "-";
  }

  const miles = km * KM_TO_MILES;

  if (miles < 0.1) {
    return "<0.1 mi";
  }

  if (miles >= 100) {
    return `${Math.round(miles).toLocaleString()} mi`;
  }

  return `${miles.toFixed(1)} mi`;
}

export function formatYearsOff(years: number): string {
  const rounded = Math.round(years);
  if (rounded === 0) {
    return "Exact";
  }

  if (rounded === 1) {
    return "1 year";
  }

  return `${rounded} years`;
}

export function formatSignedYearNumber(year: number): string {
  return year < 0 ? `-${Math.abs(Math.round(year))}` : String(Math.round(year));
}

/**
 * Accept a wide range of human inputs:
 *   "1492", "1492 CE", "500 BCE", "-500", "2560 BC", "1492 AD"
 * Returns null when nothing parseable was found.
 */
export function parseYearInput(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const match = trimmed.match(/^(-?\d{1,5})\s*(BCE|BC|CE|AD)?$/i);
  if (!match) return null;

  const value = Number.parseInt(match[1] ?? "", 10);
  if (!Number.isFinite(value)) return null;

  const era = (match[2] ?? "").toUpperCase();
  if (era === "BCE" || era === "BC") {
    return -Math.abs(value);
  }

  return value;
}
